module.exports = __webpack_public_path__ + "static/img/car_8_6_cold@3x.460f63c9.png";